import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Container,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import { useStyles } from "../style";
import { Button } from "primereact/button";
import { APP_URLS } from "../../../../utils/constant";
import EzControlledInputWithFloatingLabel from "../../../../common/EzForm/EzControlledInput/WithFloatingLabel";
import EzControlledPasswordWithFloatingLabel from "../../../../common/EzForm/EZControlledPassword/WithFloatingLabel";
import { useForm } from "react-hook-form";
import EzControlledCheckBox from "../../../../common/EzForm/EzControlledCheckBox";
import "./index.css";
import { Status, transformFormFieldValueMap, UserBreadcrumb } from "./constant";
import EzControlledDropDowntWithFloatingLabel from "../../../../common/EzForm/EzControlledDropDown/WithFloatingLabel";
import EzControlledMultiSelecttWithFloatingLabel from "../../../../common/EzForm/EzControlledMultiSelect/WithFloatingLabel";
import UserAccessRow from "./UserAccessRow";
import EzControlledCheckBoxWithLabel from "../../../../common/EzForm/EzControlledCheckBox/WithLabel";
import { getFormBaseValidationRule } from "../../../../utils/form/form-utils";
import Breadcrumb from "../../../../common/Breadcrumb";
import { useNavigate } from "react-router-dom";

const CreateUsersComponent = (props) => {
  const navigate = useNavigate();
  const {
    isEdit,
    formFieldValueMap,
    isUsersDetailSuccess,
    updateUser,
    createUser,
    initCreateUserScreen,
    isUpdateUserSuccess,
    isUserCreateSuccess,
    UserRolesDD,
    LocationsDD,
    userCreateMenuList,
    fetchUserRolesDD,
    fetchLocationsDD,
    shouldBlockNavigation,
  } = props;
  const {
    control,
    formState: { errors, isDirty },
    setValue,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: useMemo(
      () => transformFormFieldValueMap(formFieldValueMap, LocationsDD),
      [formFieldValueMap, LocationsDD]
    ),
  });
  const classes = useStyles();
  const [selectAll, setSelectAll] = useState(false);
  const [selectAllView, setSelectAllView] = useState(false);
  const [selectAllCreate, setSelectAllCreate] = useState(false);
  const [selectAllEdit, setSelectAllEdit] = useState(false);
  const [accessData, setAccessData] = useState([]);

  useEffect(() => {
    if (isUsersDetailSuccess) {
      reset(transformFormFieldValueMap(formFieldValueMap));
      setAccessData(formFieldValueMap?.menuAccessDTOS || []);
    }
  }, [isUsersDetailSuccess, formFieldValueMap, reset]);

  useEffect(() => {
    if (isUpdateUserSuccess || isUserCreateSuccess) {
      reset();
    }
  }, [isUpdateUserSuccess, isUserCreateSuccess]);

  // useEffect(() => {
  //   // Don't set dirty state after successful save
  //   if (!isUpdateUserSuccess && !isUserCreateSuccess) {
  //     shouldBlockNavigation(isDirty);
  //   }
  // }, [isDirty, shouldBlockNavigation, isUpdateUserSuccess, isUserCreateSuccess]);

  useEffect(() => {
    if (!isEdit && userCreateMenuList?.length) {
      setAccessData(userCreateMenuList);
    }
  }, [isEdit, userCreateMenuList]);
  

  useEffect(() => {
    initCreateUserScreen();
    fetchUserRolesDD();
    fetchLocationsDD();
  }, []);

  const handleChange = (targetId, field, checked, items = accessData) => {
    const updateItem = (list) => {
      return list.map((item) => {
        const itemId = item.menuId;

        if (itemId === targetId) {
          return { ...item, [field]: checked };
        }

        if (Array.isArray(item.accessDTOList)) {
          return {
            ...item,
            accessDTOList: updateItem(item.accessDTOList),
          };
        }
        return item;
      });
    };
    const updated = updateItem(items);
    if (items === accessData) {
      setAccessData(updated);
    }
    return updated;
  };

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    const togglePermissions = (items) =>
      items.map((item) => ({
        ...item,
        view: checked,
        createCrud: checked,
        editCrud: checked,
        accessDTOList: item.accessDTOList
          ? togglePermissions(item.accessDTOList)
          : [],
      }));
    const updated = togglePermissions(accessData);
    setAccessData(updated);
    setSelectAllView(checked);
    setSelectAllCreate(checked);
    setSelectAllEdit(checked);
  };

  const handleSelectAllView = (checked) => {
    setSelectAllView(checked);
    const toggleView = (items) =>
      items.map((item) => ({
        ...item,
        view: checked,
        accessDTOList: item.accessDTOList ? toggleView(item.accessDTOList) : [],
      }));
    setAccessData(toggleView(accessData));
  };

  const handleSelectAllCreate = (checked) => {
    setSelectAllCreate(checked);
    const toggleCreate = (items) =>
      items.map((item) => ({
        ...item,
        createCrud: checked,
        accessDTOList: item.accessDTOList ? toggleCreate(item.accessDTOList) : [],
      }));
    setAccessData(toggleCreate(accessData));
  };

  const handleSelectAllEdit = (checked) => {
    setSelectAllEdit(checked);
    const toggleEdit = (items) =>
      items.map((item) => ({
        ...item,
        editCrud: checked,
        accessDTOList: item.accessDTOList ? toggleEdit(item.accessDTOList) : [],
      }));
    setAccessData(toggleEdit(accessData));
  };

  const onSubmit = (formData) => {
    const permissions = [];

    const extractPermissions = (items = []) => {
      items.forEach((item) => {
        const authorityNames = [];

        if (item.view) authorityNames.push("VIEW");
        if (item.createCrud) authorityNames.push("CREATE");
        if (item.editCrud) authorityNames.push("EDIT");

        if (item.menuId) {
          const perm = {
            submoduleChildId: item.menuId,
            authorityNames, // This will be an empty array if no permissions are selected
          };

          // Only include parentId if editing
          if (isEdit && item.parentId !== undefined) {
            perm.parentId = item.parentId;
          }

          permissions.push(perm);
        }

        if (
          Array.isArray(item.accessDTOList) &&
          item.accessDTOList.length > 0
        ) {
          extractPermissions(item.accessDTOList);
        }
      });
    };

    extractPermissions(accessData);
    const idValue = Number(
      isEdit ? formData.id : localStorage.getItem("userId")
    );

    const payload = {
      [isEdit ? "id" : "loginUserId"]: idValue,
      username: formData.username,
      password: formData.password,
      alias: formData.alias,
      companyName: formData.companyName,
      role: UserRolesDD.find((opt) => opt.id === formData.roleId)?.name || "",
      status: Status.find((opt) => opt.id === formData.status)?.name || "",
      location: formData.location || [0],
      permissions,
    };

    if (isEdit) {
      updateUser({ id: idValue, data: payload });
    } else {
      createUser(payload);
    }
  };

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const renderPageHeaderSection = () => (
    <div className="make-relative sub-header">
      <div className="maintitlediv">
        <div className="ml-3">
          <h4 className="pagetitle">
            {isEdit
              ? `Update User: ${formFieldValueMap?.username}`
              : "Create User"}
          </h4>
        </div>
        <div className="buttonarea">
          <Button
            tooltip={"Back to Users"}
            tooltipOptions={{ position: "left" }}
            label={"Back to Users"}
            className={`p-button `}
            style={{ borderRadius: "10px" }}
            onClick={() => navigate(APP_URLS.SYSTEM_USERS.HOME)}
          />
        </div>
      </div>
    </div>
  );
  return (
    <Container maxWidth="lg">
      <Breadcrumb list={UserBreadcrumb} />
      <EzToast
        severity={TOAST_SEVERITY.ERROR}
        toastTitle="Please select category from list"
        shouldShowToast={false}
      />
      <div className={`containerbox ${classes.bg}`}>
        {renderPageHeaderSection()}
        <div className="form-demo" style={{ marginTop: "20px" }}>
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <Grid container spacing={2} mt={2}>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <EzControlledInputWithFloatingLabel
                  name="username"
                  control={control}
                  label="Username"
                  isError={errors["username"]}
                  errorMsg={getFormErrorMessage("username")}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <EzControlledPasswordWithFloatingLabel
                  name="password"
                  type="password"
                  control={control}
                  label="Password"
                  isError={errors["password"]}
                  errorMsg={getFormErrorMessage("password")}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <EzControlledDropDowntWithFloatingLabel
                  name="roleId"
                  control={control}
                  rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                  optionLabel={"name"}
                  optionValue={"id"}
                  options={UserRolesDD}
                  isError={errors["roleId"]}
                  errorMsg={getFormErrorMessage("roleId")}
                  label="Role"
                  labelClassName={"ml-2"}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <EzControlledDropDowntWithFloatingLabel
                  name="status"
                  control={control}
                  rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                  optionLabel="name"
                  optionValue="id"
                  options={Status}
                  isError={errors["status"]}
                  errorMsg={getFormErrorMessage("status")}
                  label="Status"
                  labelClassName={"ml-2"}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <EzControlledMultiSelecttWithFloatingLabel
                  name="location"
                  control={control}
                  label="Location"
                  labelClassName="ml-2"
                  rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
                  options={LocationsDD}
                  optionLabel="name"
                  optionValue="id"
                  isError={errors.location}
                  errorMsg={errors.location?.message}                 
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3}>
                <EzControlledInputWithFloatingLabel
                  name="alias"
                  control={control}
                  label="Alias"
                  isError={errors["alias"]}
                  errorMsg={getFormErrorMessage("alias")}
                />
              </Grid>
              {isEdit && (
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <EzControlledInputWithFloatingLabel
                    name="companyName"
                    control={control}
                    label="Company Name"
                    disabled={true}
                    isError={errors["companyName"]}
                    errorMsg={getFormErrorMessage("companyName")}
                  />
                </Grid>
              )}
              {isEdit && (
                <>
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <EzControlledInputWithFloatingLabel
                      name="editTime"
                      control={control}
                      label="Edit Time"
                      disabled={true}
                      isError={errors["editTime"]}
                      errorMsg={getFormErrorMessage("editTime")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <EzControlledInputWithFloatingLabel
                      name="modifiedBy"
                      control={control}
                      label="Edit By"
                      disabled={true}
                      isError={errors["modifiedBy"]}
                      errorMsg={getFormErrorMessage("modifiedBy")}
                    />
                  </Grid>
                </>
              )}
            </Grid>
            <Grid>
              <div className="user-access-section">
                <h1 className="user-access-heading">User Access</h1>
                <EzControlledCheckBoxWithLabel
                  name="selectAll"
                  value={selectAll}
                  id="1"
                  control={control}
                  isError={errors["selectAll"]}
                  label="Select All"
                  labelClassName={"ml-2 mt-2"}
                  onChange={handleSelectAll}
                />
              </div>
              <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className="table-header-cell module-name-cell">
                        Module Name
                      </TableCell>
                      <TableCell className="table-header-cell permission-cell">
                        View
                        <div>
                          <EzControlledCheckBox
                            name="selectAllView"
                            control={control}
                            value={selectAllView}
                            onChange={e => handleSelectAllView(e.checked)}
                          />
                        </div>
                      </TableCell>
                      <TableCell className="table-header-cell permission-cell">
                        Create
                        <div>
                          <EzControlledCheckBox
                            name="selectAllCreate"
                            control={control}
                            value={selectAllCreate}
                            onChange={e => handleSelectAllCreate(e.checked)}
                          />
                        </div>
                      </TableCell>
                      <TableCell className="table-header-cell permission-cell">
                        Edit
                        <div>
                          <EzControlledCheckBox
                            name="selectAllEdit"
                            control={control}
                            value={selectAllEdit}
                            onChange={e => handleSelectAllEdit(e.checked)}
                          />
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {accessData?.map((module) => (
                      <UserAccessRow
                        key={module?.menuId}
                        module={module}
                        handleChange={handleChange}
                        control={control}
                        errors={errors}
                      />
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Button
              type="submit"
              label={isEdit ? "Update" : "Save"}
              className="mt-2 p-button-raised"
              style={{ width: "100px", maxWidth: "100%" }}
            />
          </form>
        </div>
      </div>
    </Container>
  );
};

export default CreateUsersComponent;
